const documentCurrentScript = document.currentScript as
  | (HTMLOrSVGScriptElement & { src: string })
  | undefined

const currentScriptUrl = documentCurrentScript?.src || import.meta.url

const domain = (() => {
  if (process.env.NODE_ENV === 'development' || !currentScriptUrl) {
    return 'https://chilipiper.team:4003'
  }

  const url = new URL(currentScriptUrl)
  const hostname = url.hostname
  const parts = hostname.split('.')

  const result = parts.length > 2 ? parts.slice(-2).join('.') : hostname

  // Tracking script runs on cpcdp.io/cpcdp.in/cpcdp.com — these are expected domains
  if (result.startsWith('cpcdp.')) {
    return result
  }

  if (!result.startsWith('chilipiper.')) {
    console.warn(
      'Could not find CP domain in snippet URL. Be aware that this warning means snippet is loaded from a different domain and may not work as expected.'
    )

    return 'chilipiper.com'
  }

  return result
})()

const getCpcdpDomain = (env: string): string => {
  if (env === 'staging') return 'cpcdp.io'
  if (env === 'testing') return 'cpcdp.in'
  return 'cpcdp.com'
}

const getTrackingUrl = (env: string) => {
  return `https://ingest.j.${getCpcdpDomain(env)}/p.js`
}

const getTrackingScriptUrl = (env: string, tenantSubdomain: string): string => {
  return `https://${tenantSubdomain}.${getCpcdpDomain(env)}/web-data/tracking/index.js`
}

const sentryDsn = process.env.SENTRY_DSN as string

const currentScriptUrlObject = currentScriptUrl ? new URL(currentScriptUrl) : undefined
const baseUrl =
  process.env.NODE_ENV !== 'development' && currentScriptUrlObject
    ? `${currentScriptUrlObject.protocol}//${currentScriptUrlObject.host}`
    : 'https://chilipiper.team:4004'
const baseIframeUrl =
  process.env.NODE_ENV !== 'development' && currentScriptUrlObject
    ? `${currentScriptUrlObject.protocol}//${currentScriptUrlObject.host}`
    : 'https://chilipiper.team:4007'

export const environment = {
  baseUrl,
  baseIframeUrl,
  sentryDsn,
  domain,
  getTrackingUrl,
  getTrackingScriptUrl,
}
